import { useMemo } from 'react'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import Product from '@groovehq/internal-design-system/lib/components/Shopify/Product/Product'
import { moneyString } from 'util/currency'
import { formatNumberWithSeparators } from 'util/numbers'

import { styles } from './styles'

const ProductItem = ({
  name,
  image,
  sku,
  stock,
  currency,
  price,
  orderItems,
  variantId,
}) => {
  const alreadyAdded = useMemo(() => orderItems.find(i => i.id === variantId), [
    orderItems,
    variantId,
  ])
  return (
    <>
      <Product.Image image={image} alt={name} />
      <Product name={name} css={styles.product}>
        {sku}
      </Product>
      <span css={[styles.stock, alreadyAdded && text.styles.italic]}>
        {alreadyAdded
          ? 'Item already added'
          : `${formatNumberWithSeparators(stock)} in stock`}
      </span>
      <span className="grui flex-1 text-right">
        {moneyString({ amount: price * 100, currencyCode: currency })}
      </span>
    </>
  )
}

export default ProductItem
